import global from "../global.js";
import RateCap from "../utils/RateCap.js";

import {DIRECTION_SOUTH_WEST, DIRECTION_SOUTH_EAST} from "./Axis.js";
import Transform from "./Transform.js";

const log = global.log.getLogger("f_mtac.scene.sub_grid");
log.setLevel(log.levels.INFO);

/**
 *
 * @param {*} svg
 * @param {*} conf
 * @param {*} coordinates exact square coordinates / NOT D3 coordinate
 */
let SubGrid = function (svg, conf, coordinates) {
    this.sub_grid_layer = global.svg.layer_get("sub_grid");

    // checking for any existing ressources
    if (!global.d3.select("#sub_grid g").size() > 0) {
        this.sub_grid = this.sub_grid_layer.append("g").attr("class", "sub_grid");
    } else {
        this.sub_grid = global.d3.select("#sub_grid g");
    }

    if (!global.d3.select("#sub_grid #posx" + coordinates.x + "posy" + coordinates.y).size() > 0) {
        this.sub_grid.append("rect").attr("id", `posx${coordinates.x}posy${coordinates.y}`);
    }

    svg.layer_insert("sub_grid", "frame");

    /**
     * @brief compute position on D3, declare the CSS of the sub_grid, place the sub_grid on D3, create HTML element
     */
    const draw = () => {
        log.debug("SubGrid.draw IN :");
        // compute D3 value of a square
        this.position_x = coordinates.x * conf.get("square.width") + conf.get("origin.x");
        this.position_y = coordinates.y * conf.get("square.width") + conf.get("origin.y");

        const GC = conf.get("grid.color"),
            GO = conf.get("grid.opacity");

        const SW = conf.get("square.width"),
            SH = conf.get("square.height");

        global.scene.map.grid.sub_grid_pattern_square
            //.attr("x", 0) useless the square is display inside the pattern
            //.attr("y", 0)
            .attr("width", SW / 10) // square width
            .attr("height", SH / 10) // square height
            .style("fill", "none")
            .style("stroke", GC)
            .style("opacity", GO);

        let _x = conf.get("frame.reference.position") >= DIRECTION_SOUTH_EAST ? 15 : conf.get("position.x"); // standard

        let _y =
            conf.get("frame.reference.position") >= DIRECTION_SOUTH_WEST && conf.get("frame.reference.position") <= DIRECTION_SOUTH_EAST
                ? conf.get("position.y") + (((conf.get("origin.y") - conf.get("position.y")) / SW) % 1) * SW
                : conf.get("position.y");

        global.scene.map.grid.sub_grid_pattern
            .attr("x", _x)
            .attr("y", _y)
            .attr("width", SW / 10)
            .attr("height", SH / 10);

        this.sub_grid = this.sub_grid_layer.select("g.sub_grid");

        // linking the style to the element
        this.sub_grid.select(`#posx${coordinates.x}posy${coordinates.y}`).attr("x", this.position_x).attr("y", this.position_y).attr("width", SW).attr("height", SH).attr("fill", "url(#sub_grid_pattern)");
    };

    /**
     * @brief used for first drawing of the sub_grid and initialize the sub_grid with the correct transform and translate attributes, , afterward it will updates accordingly with the grid.
     */
    this.init = () => {
        log.debug("SubGrid.init IN :");
        draw();
        this.sub_grid.attr("transform", "translate(" + global.scene.root_transform.x + "," + global.scene.root_transform.y + ") scale(" + global.scene.root_transform.k + ")");
    };

    // RateCap handles a mechanism that delaies the drawing few milliseconds later
    // With RateCap, several quick calls to draw() may be result in one draw
    const draw_cap = new RateCap(() => {
        draw();
    }, 50);
    this.draw = () => {
        draw_cap.poll();
    };

    this.transform = new Transform({x: 0, y: 0, k: 1});
    /**
     * @brief Redraw when translation (x,y) or scale (k) change.
     * Translation happens also when the browser window is resized
     */
    this.transform.on_change(({x, y, k}) => {
        log.debug("SubGrid.transform.on_change IN :");
        this.sub_grid.attr("transform", "translate(" + x + "," + y + ") scale(" + k + ")");
    });
};
export default SubGrid;
